<template>
  <component :is="screenComponent" />
</template>

<script>
import CommonMeterScreen from './common/index.vue'
import TaimakeMeterScreen from './customized/taimake/index.vue'
export default {
  name: 'MeterLargeScreen',
  components: {
    CommonMeterScreen,
    TaimakeMeterScreen
  },
  data () {
    return {
      screenComponent: null,
      screenConfig: {
        // 泰马克
        '34c19e8382bf45cc8249d6e4b501babd': TaimakeMeterScreen,
      }
    }
  },
  created () {
    this.setScreenComponent()
  },
  methods: {

    /**
     *  设置大屏组件
     */
    setScreenComponent () {
      const queryStationId = this.$route.params.id
      if (queryStationId) {
        const configKeys = Object.keys(this.screenConfig)
        this.screenComponent = configKeys.includes(queryStationId) ? this.screenConfig[queryStationId] : CommonMeterScreen
      }
    }
  }
}
</script>
